import React, { Component } from 'react'

/*
	Image de couverture avec fond de repli et fondu à la fin du chargement :
	supprime le flash blanc pendant le décodage de l'image au montage.
*/
class CoverImage extends Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			loaded: false
		}
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps.src !== this.props.src)
			this.setState({ loaded: false })
	}

	handleLoad = () => {
		this.setState({ loaded: true })
	}

	render()
	{
		//hauteur fixe + object-fit cover : l'image remplit toujours le bandeau,
		//recadrée au centre, quelle que soit sa taille d'origine
		//(le contenu recouvre le bandeau à 192px ou 25vh selon l'écran)
		return (
			<div className={this.props.className} style={{ backgroundColor: '#e2e2e6', height: '30vh', minHeight: '220px' }}>
				<img
					src={this.props.src}
					alt={this.props.alt}
					onLoad={this.handleLoad}
					style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: (this.state.loaded) ? 1 : 0, transition: 'opacity 0.2s ease-out' }}
				/>
			</div>
		)
	}
}

export default CoverImage
